interface ListHeaderProps {
  count: number;
}

const ListHeader = ({ count }: ListHeaderProps) => {
  return (
    <div className='flex items-center justify-between mb-8'>
      <h2 className='text-xl font-black text-gray-800 flex items-center gap-3 px-1'>
        Lista de Pedidos ({count})
      </h2>
    </div>
  );
};

export default ListHeader;
